// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__e-sGm"};